import store from '../store'

export default (to, from, next) => {
  if (!store.getters['auth/user'] || store.getters['auth/user'].role_id !== 5) {
    window.location = config.public_url + '/login'
  } else {
    next()
  }
}
